import React, { useState, useEffect } from 'react'
import { supabase } from '../../supabaseClient'
import Swal from 'sweetalert2'

const bgImage   = "https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/Background/Login_BG.png"  
const logoImage = "https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/Background/CG%20LOGO.png"   

export default function SetupAdmin() {
    const [newEmail, setNewEmail] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [otp, setOtp] = useState(["", "", "", "", "", ""])
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [currentEmail, setCurrentEmail] = useState("")
    const [step, setStep] = useState(1) 
    const [otpSent, setOtpSent] = useState(false)
    const [resendLoading, setResendLoading] = useState(false)
    const [countdown, setCountdown] = useState(0)
    const [passwordValidation, setPasswordValidation] = useState({
        length: false,
        upperCase: false,
        number: false,
        special: false
    })
    const [emailValidation, setEmailValidation] = useState({
        isValid: false,
        message: ''
    })
    const [username, setUsername] = useState("")
    const [usernameValidation, setUsernameValidation] = useState({
        isValid: false,
        message: ''
    })

    useEffect(() => {
        const email = sessionStorage.getItem('userEmail')
        if (!email) {
            window.location.href = '/login'
            return
        }
        setCurrentEmail(email)
    }, [])

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
            return () => clearTimeout(timer)
        }
    }, [countdown])

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .swal2-confirm {
                background-color: #FF6F3C !important;
                border: none !important;
            }
            .swal2-confirm:hover {
                background-color: #ff4c0b !important;
            }
            .swal2-cancel:hover {
                background-color: #5a5a5a !important;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .swal2-confirm {
                background-color: #A0826D !important;
                border: none !important;
            }
            .swal2-confirm:hover {
                background-color: #8B5A3C !important;
            }
            .swal2-cancel {
                background-color: #6b7280 !important;
                border: none !important;
            }
            .swal2-cancel:hover {
                background-color: #5a5a5a !important;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    const validatePassword = (password) => {
        const validation = {
            length: password.length >= 8,
            upperCase: /[A-Z]/.test(password),
            number: /[0-9]/.test(password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
        }
        setPasswordValidation(validation)
        return validation.length && validation.upperCase && validation.number
    }

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const isValidFormat = emailRegex.test(email)

        const isValidLength = email.length <= 254 && email.length > 0

        let validation = {
            isValid: false,
            message: ''
        }

        if (!email) {
            validation.message = ''
        } else if (!isValidLength) {
            validation.message = 'Email is too long'
        } else if (!isValidFormat) {
            validation.message = 'Please enter a valid email address'
            validation.isValid = false
        } else {
            validation.message = 'Valid email format'
            validation.isValid = true
        }

        setEmailValidation(validation)
        return validation.isValid
    }

    const validateUsername = (username) => {
        const usernameRegex = /^[a-zA-Z0-9_]{3,50}$/
        const isValidFormat = usernameRegex.test(username)

        let validation = {
            isValid: false,
            message: ''
        }
        if (!username) {
        validation.message = ''
        } else if (username.length < 3) {
            validation.message = 'Username must be at least 3 characters'
            validation.isValid = false
        } else if (username.length > 50) {
            validation.message = 'Username is too long (max 50 characters)'
            validation.isValid = false
        } else if (!isValidFormat) {
            validation.message = 'Only letters, numbers, and underscores allowed'
            validation.isValid = false
        } else {
            validation.message = 'Valid username'
            validation.isValid = true
        }
        
        setUsernameValidation(validation)
        return validation.isValid
    }

    const validateForm = () => {
        const isEmailValid = validateEmail(newEmail)
        const isPasswordValid = validatePassword(newPassword

        )
        if (!isEmailValid) {
            setError('Please enter a valid email')
            return false
        }

        if (!isPasswordValid) {
            setError('Password must be at least 8 characters with an uppercase letter, number and special character')
            return false
        }

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match')
            return false
        }

        return true
    }

    const checkEmailExists = async (email) => {
        try {
            const { data, error } = await supabase
                .from('admin_accounts')
                .select('email')
                .eq('email', email)
                .single()

            if (error && error.code !== 'PGRST116') { 
                throw error
            }

            return !!data 
        } catch (err) {
            console.error('Error checking email:', err)
            return false
        }
    }

    const checkUsernameExists = async (username) => {
        try {
            const { data, error } = await supabase
                .from('admin_accounts')
                .select('username')
                .eq('username', username)
                .single()

            if (error && error.code !== 'PGRST116') {
                throw error
            }

            return !!data
        } catch (err) {
            console.error('Error checking username:', err)
            return false
        }
    }

    const handleSendOTP = async () => {
    setError('')

    if (!username.trim() || !newEmail.trim() || !newPassword.trim() || !confirmPassword.trim()) {
        await Swal.fire({
            icon: 'warning',
            title: 'Missing Information',
            text: 'Please fill in all required fields before proceeding.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF6F3C',
        })
        return
    }

    if (!validateForm()) return

    const usernameExists = await checkUsernameExists(username)
    if (usernameExists) {
        await Swal.fire({
            icon: 'error',
            title: 'Username Already Taken',
            text: 'This username is already in use.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF6F3C',
        })
        return
    }

    const emailExists = await checkEmailExists(newEmail)
    if (emailExists) {
        await Swal.fire({
            icon: 'error',
            title: 'Email Already Exists',
            text: 'This email address is already registered.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF6F3C',
        })
        return
    }

    setLoading(true)

    try {
        const generatedOTP = Math.floor(100000 + Math.random() * 900000).toString();
        
        console.log('Generated OTP:', generatedOTP);
        
        const { error: deleteError } = await supabase
            .from('admin_otp_codes')
            .delete()
            .eq('email', newEmail);

        if (deleteError) {
            console.warn('Delete old OTP warning:', deleteError);
        }
        
        const { data: otpData, error: storeError } = await supabase
            .from('admin_otp_codes')
            .insert({
                email: newEmail,
                otp: generatedOTP,
                user_type: 'admin',
                verified: false,
                expires_at: new Date(Date.now() + 10 * 60 * 1000).toISOString(),
                created_at: new Date().toISOString()
            })
            .select();

        if (storeError) {
            console.error('Store OTP error:', storeError);
            throw new Error('Failed to store OTP: ' + storeError.message);
        }

        console.log('OTP stored successfully:', otpData);

        const { data: functionData, error: functionError } = await supabase.functions.invoke('send-otp-email-v2', {
            body: {
                email: newEmail,
                otp: generatedOTP
            }
        });

        console.log('Function response:', functionData);

        if (functionError) {
            console.error('Function error:', functionError);
            throw new Error(functionError.message || 'Failed to send email');
        }

        if (!functionData?.success) {
            throw new Error(functionData?.error || 'Failed to send email');
        }

        console.log('Email sent successfully!');

        await Swal.fire({
            icon: 'success',
            title: 'Verification Code Sent!',
            text: `A 6-digit code has been sent to ${newEmail}`,
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF6F3C',
            timer: 3000,
            timerProgressBar: true,
        });
        
        setOtpSent(true);
        setStep(2);
        setCountdown(60);

    } catch (err) {
        console.error('Send OTP error:', err);
        await Swal.fire({
            icon: 'error',
            title: 'Failed to Send Code',
            text: err.message || 'Could not send verification code. Please try again.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF6F3C',
        });
    } finally {
        setLoading(false);
    }
}

    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return

        const newOtp = [...otp]
        newOtp[index] = value
        setOtp(newOtp)

        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus()
        }
    }

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            document.getElementById(`otp-${index - 1}`).focus()
        }
    }

    const handlePaste = (e) => {
        e.preventDefault()
        const pastedData = e.clipboardData.getData('text').slice(0, 6)
        if (!/^\d+$/.test(pastedData)) return

        const newOtp = pastedData.split('').concat(Array(6).fill('')).slice(0, 6)
        setOtp(newOtp)

        const lastIndex = Math.min(pastedData.length - 1, 5)
        document.getElementById(`otp-${lastIndex}`).focus()
    }

    const handleResendOTP = async () => {
       if (countdown > 0) return
        setResendLoading(true)
        setError('')

        try {
            const generatedOTP = Math.floor(100000 + Math.random() * 900000).toString()

            // Delete old OTP first
            const { error: deleteError } = await supabase
                .from('admin_otp_codes')
                .delete()
                .eq('email', newEmail)

            if (deleteError) console.warn('Delete old OTP warning:', deleteError)

            // Store new OTP
            const { error: storeError } = await supabase
                .from('admin_otp_codes')
                .insert({
                    email: newEmail,
                    otp: generatedOTP,
                    user_type: 'admin',
                    verified: false,
                    expires_at: new Date(Date.now() + 10 * 60 * 1000).toISOString(),
                    created_at: new Date().toISOString()
                })

            if (storeError) throw new Error('Failed to store OTP: ' + storeError.message)

            // Send email
            const { data: functionData, error: functionError } = await supabase.functions.invoke('send-otp-email-v2', {
                body: { email: newEmail, otp: generatedOTP }
            })

            if (functionError) throw new Error(functionError.message || 'Failed to send email')
            if (!functionData?.success) throw new Error(functionData?.error || 'Failed to send email')

            await Swal.fire({
                icon: 'success',
                title: 'Code Resent!',
                text: 'A new verification code has been sent to your email.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FF6F3C',
                timer: 2000,
                timerProgressBar: true,
                background: '#ffffff',
                color: '#1a1a1a'
            })

            setCountdown(60)
            setOtp(["", "", "", "", "", ""])
            document.getElementById('otp-0')?.focus()

        } catch (err) {
            console.error('Resend error:', err)
            setError('Failed to resend code. Please try again.')
        } finally {
            setResendLoading(false)
        }
    }

    const handleCompleteSetup = async (e) => {
        e.preventDefault()
        setError('')

        const otpCode = otp.join('')

        if (otpCode.length !== 6) {
            setError('Please enter the complete 6-digit code')
            return
        }

        setLoading(true)

        try {
            const { data: otpValid, error: verifyError } = await supabase
                .rpc('verify_admin_otp', {
                    user_email: newEmail,
                    input_otp: otpCode
                });

            if (verifyError) throw verifyError;

            if (!otpValid) {
                setError('Invalid or expired verification code')
                setOtp(["", "", "", "", "", ""])
                document.getElementById('otp-0')?.focus()
                return
            }

            const { data, error: updateError } = await supabase
                .rpc('update_admin_credentials', {
                    old_email: currentEmail,
                    new_username: username,
                    new_email: newEmail,
                    new_password: newPassword
                });

            if (updateError) throw updateError;

            sessionStorage.setItem('userEmail', newEmail)
            
            await Swal.fire({
                icon: 'success',
                title: 'Setup Complete!',
                text: 'Your admin account has been set up successfully. Please login with your new credentials.',
                confirmButtonText: 'Go to Login',
                confirmButtonColor: '#FF6F3C',
                allowOutsideClick: false,
                background: '#f9fafb',
                customClass: {
                    popup: 'rounded-2xl',
                    title: 'text-gray-800 font-bold',
                    htmlContainer: 'text-gray-600'
                }
            })
            
            sessionStorage.removeItem('isAdminAuthenticated')
            sessionStorage.removeItem('userEmail')
            sessionStorage.removeItem('userType')
            window.location.href = '/login'

        } catch (err) {
            console.error('Setup error:', err)
            await Swal.fire({
                icon: 'error',
                title: 'Setup Failed',
                text: 'Failed to complete setup. Please try again.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FF6F3C',
                background: '#f9fafb',
                customClass: {
                    popup: 'rounded-2xl',
                    title: 'text-gray-800 font-bold',
                    htmlContainer: 'text-gray-600'
                }
            })
        } finally {
            setLoading(false)
        }
    }

    const handleBackToForm = () => {
        setStep(1)
        setOtpSent(false)
        setOtp(["", "", "", "", "", ""])
        setError('')
    }

    const handleBackToLogin = async () => {
    const result = await Swal.fire({
        icon: 'warning',
        title: 'Cancel Setup?',
        text: 'Are you sure you want to go back? You will need to complete the setup later.',
        showCancelButton: true,
        confirmButtonText: 'Yes, Go Back',
        cancelButtonText: 'Stay Here',
        confirmButtonColor: '#FF6F3C',
        cancelButtonColor: '#6B7280',
        background: '#f9fafb',
        customClass: {
            popup: 'rounded-2xl',
            title: 'text-gray-800 font-bold',
            htmlContainer: 'text-gray-600'
        }
    })

    if (result.isConfirmed) {
        sessionStorage.clear() 
        window.location.href = '/login'
    }
}

    return (
        <div
            className="min-h-screen flex items-center justify-center p-4"            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
            >
                {step === 1 && (
                <div
                    className="rounded-2xl shadow-2xl p-5 sm:p-8 w-full max-w-2xl"                    style={{ background: 'rgba(30, 20, 15, 0.92)', backdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.08)' }}
                >
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">

                        {/* Left: Logo */}
                        <div className="flex items-center justify-center w-full sm:w-[200px] shrink-0">
                        <img src={logoImage} alt="Coffee Gus·To" className="w-44 object-contain" />
                        </div>

                        {/* Right: Form */}
                        <div className="flex-1 min-w-0">
                        <h1 className="text-2xl font-bold text-white mb-1">First Time Setup</h1>
                        <p className="text-sm text-gray-400 mb-5">Please set your personal admin credentials</p>

                        {error && (
                            <div className="bg-red-900/50 border border-red-600 text-red-300 px-4 py-3 rounded-lg mb-4 text-sm">
                            {error}
                            </div>
                        )}

                        <div className="space-y-3">

                            {/* Current Email (read-only) */}
                            <div>
                            <label className="block text-xs font-semibold text-gray-400 mb-1">Current Email Address</label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/></svg>
                                </span>
                                <input
                                type="text"
                                value={currentEmail}
                                disabled
                                className="w-full pl-9 pr-3 py-2.5 bg-[#fff] border border-[#333] rounded-lg text-gray-500 text-sm cursor-not-allowed"
                                />
                            </div>
                            </div>

                            {/* Username */}
                            <div>
                            <label className="block text-xs font-semibold text-gray-400 mb-1">
                                Username <span className="text-red-400">*</span>
                            </label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4"/></svg>
                                </span>
                                <input
                                type="text"
                                value={username}
                                onChange={(e) => {
                                    const value = e.target.value.trim()
                                    if (value.length <= 50) { setUsername(value); validateUsername(value) }
                                }}
                                onBlur={() => validateUsername(username)}
                                placeholder="Enter your Username"
                                maxLength={50}
                                className={`w-full pl-9 pr-9 py-2.5 bg-[#fff] border rounded-lg text-black text-sm placeholder-gray-600 focus:ring-2 focus:border-transparent outline-none ${
                                    username && usernameValidation.isValid
                                    ? 'border-green-500 focus:ring-green-500'
                                    : username && !usernameValidation.isValid
                                    ? 'border-red-500 focus:ring-red-500'
                                    : 'border-[#333] focus:ring-[#FF6F3C]'
                                }`}
                                required
                                />
                                {username && (
                                <span className="absolute right-3 top-1/2 -translate-y-1/2">
                                    {usernameValidation.isValid
                                    ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" className="text-green-500"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"/></svg>
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" className="text-red-500"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41z"/></svg>
                                    }
                                </span>
                                )}
                            </div>
                            {username && usernameValidation.message && (
                                <p className={`text-xs mt-1 ${usernameValidation.isValid ? 'text-green-500' : 'text-red-500'}`}>
                                {usernameValidation.message}
                                </p>
                            )}
                            </div>

                            {/* New Email */}
                            <div>
                            <label className="block text-xs font-semibold text-gray-400 mb-1">New Email Address</label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/></svg>
                                </span>
                                <input
                                type="email"
                                value={newEmail}
                                onChange={(e) => {
                                    const value = e.target.value
                                    if (value.length <= 254) { setNewEmail(value); validateEmail(value) }
                                }}
                                onBlur={() => validateEmail(newEmail)}
                                placeholder="Enter your New Email Address"
                                maxLength={254}
                                className="w-full pl-9 pr-3 py-2.5 bg-[#fff] border border-[#333] rounded-lg text-black text-sm placeholder-gray-600 focus:ring-2 focus:ring-[#FF6F3C] focus:border-transparent outline-none"
                                required
                                />
                            </div>
                            </div>

                            {/* New Password */}
                            <div>
                            <label className="block text-xs font-semibold text-gray-400 mb-1">New Password</label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"/><path strokeLinecap="round" d="M6 10V8a6 6 0 1 1 12 0v2"/></g></svg>
                                </span>
                                <input
                                type={showPassword ? 'text' : 'password'}
                                value={newPassword}
                                onChange={(e) => { setNewPassword(e.target.value); validatePassword(e.target.value) }}
                                onBlur={() => validatePassword(newPassword)}
                                placeholder="Enter your New Password"
                                className="w-full pl-9 pr-10 py-2.5 bg-[#fff] border border-[#333] rounded-lg text-black text-sm placeholder-gray-600 focus:ring-2 focus:ring-[#FF6F3C] focus:border-transparent outline-none"
                                required
                                maxLength={128}
                                />
                                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300">
                                {showPassword
                                    ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path d="M2 12c1.6-4.097 5.336-7 10-7s8.4 2.903 10 7c-1.6 4.097-5.336 7-10 7s-8.4-2.903-10-7"/></g></svg>
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a13.4 13.4 0 0 0 3 2.685M21 10a13.4 13.4 0 0 1-3 2.685m-8 1.624L9.5 16.5m.5-2.19a10.6 10.6 0 0 0 4 0m-4 0a11.3 11.3 0 0 1-4-1.625m8 1.624l.5 2.191m-.5-2.19a11.3 11.3 0 0 0 4-1.625m0 0l1.5 1.815M6 12.685L4.5 14.5"/></svg>
                                }
                                </button>
                            </div>
                            </div>

                            {/* Confirm Password */}
                            <div>
                            <label className="block text-xs font-semibold text-gray-400 mb-1">Confirm New Password</label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"/><path strokeLinecap="round" d="M6 10V8a6 6 0 1 1 12 0v2"/></g></svg>
                                </span>
                                <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm your New Password"
                                maxLength={128}
                                className={`w-full pl-9 pr-10 py-2.5 bg-[#fff] border rounded-lg text-black text-sm placeholder-gray-600 focus:ring-2 focus:border-transparent outline-none ${
                                    confirmPassword && confirmPassword === newPassword
                                    ? 'border-green-500 focus:ring-green-500'
                                    : confirmPassword && confirmPassword !== newPassword
                                    ? 'border-red-500 focus:ring-red-500'
                                    : 'border-[#333] focus:ring-[#FF6F3C]'
                                }`}
                                required
                                />
                                <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300">
                                {showConfirmPassword
                                    ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path d="M2 12c1.6-4.097 5.336-7 10-7s8.4 2.903 10 7c-1.6 4.097-5.336 7-10 7s-8.4-2.903-10-7"/></g></svg>
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a13.4 13.4 0 0 0 3 2.685M21 10a13.4 13.4 0 0 1-3 2.685m-8 1.624L9.5 16.5m.5-2.19a10.6 10.6 0 0 0 4 0m-4 0a11.3 11.3 0 0 1-4-1.625m8 1.624l.5 2.191m-.5-2.19a11.3 11.3 0 0 0 4-1.625m0 0l1.5 1.815M6 12.685L4.5 14.5"/></svg>
                                }
                                </button>
                            </div>
                            {confirmPassword && (
                                <p className={`text-xs mt-1 ${confirmPassword === newPassword ? 'text-green-500' : 'text-red-500'}`}>
                                {confirmPassword === newPassword ? 'Passwords match' : 'Passwords do not match'}
                                </p>
                            )}
                            </div>

                            {/* Password validation */}
                            {newPassword && (
                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">                                {[
                                { key: 'length', label: '8+ chars' },
                                { key: 'upperCase', label: 'Uppercase' },
                                { key: 'number', label: 'Number' },
                                { key: 'special', label: 'Special' },
                                ].map(({ key, label }) => (
                                <div key={key} className="flex items-center gap-1 text-xs">
                                    {passwordValidation[key]
                                    ? <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" className="text-green-500 flex-shrink-0"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"/></svg>
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" className="text-gray-600 flex-shrink-0"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2"/></svg>
                                    }
                                    <span className={passwordValidation[key] ? 'text-green-500' : 'text-gray-600'}>{label}</span>
                                </div>
                                ))}
                            </div>
                            )}

                            {/* Remember Me + Forgot Password */}
                            <div className="flex items-center justify-between pt-1">
                            <label className="flex items-center gap-2 text-sm text-gray-400 cursor-pointer">
                                <input type="checkbox" className="accent-[#FF6F3C]" />
                                Remember Me
                            </label>
                            <button type="button" className="text-sm text-gray-400 hover:text-white transition">
                                Forgot Password?
                            </button>
                            </div>

                            {/* Buttons */}
                            <button
                                type="button"
                                onClick={handleSendOTP}
                                disabled={loading}
                                className="w-full bg-[#FF6F3C] hover:bg-[#e85a28] text-white font-semibold py-2.5 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                            >
                            {loading ? 'Sending...' : 'Complete Setup'}
                            </button>

                            <button
                            type="button"
                            onClick={handleBackToLogin}
                            className="w-full border border-[#444] text-gray-300 hover:bg-[#2a2a2a] font-semibold py-2.5 rounded-lg transition duration-200 text-sm"
                            >
                            Cancel
                            </button>
                        </div>

                        {/* Footer */}
                        <div className="mt-4 flex items-start gap-2 text-xs text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" className="flex-shrink-0 mt-0.5"><path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M11 7h2v2h-2zm0 4h2v6h-2z"/></svg>
                            <p>This is a secure admin area. Only authorized personnel with valid credentials can access this system. All login attempts are logged and monitored.</p>
                        </div>
                        <p className="text-center text-xs text-gray-600 mt-2">Need access? Contact your system administrator</p>
                        </div>
                    </div>
                </div>
                )}
                
                {/* STEP 2: OTP Verification */}
                {step === 2 && (
                    <div
                        className='rounded-2xl shadow-2xl p-5 sm:p-8 w-full max-w-xl'                        style={{ background: 'rgba(30, 20, 15, 0.95)', backdropFilter: 'blur(16px)', border: '1px solid rgba(255,255,255,0.10)' }}
                    >
                        <form onSubmit={handleCompleteSetup} className='space-y-6'>
                            <div>
                                <label className='block text-sm font-semibold text-white mb-3 text-center'>
                                    Enter Verification Code
                                </label>
                                <div className='flex gap-1.5 sm:gap-2 justify-center'>                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type='text'
                                            inputMode='numeric'
                                            pattern='[0-9]*'
                                            maxLength='1'
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(index, e)}
                                            onPaste={handlePaste}
                                            autoComplete='off'
                                            autoCorrect='off'
                                            autoCapitalize='off'
                                            spellCheck='false'
                                            className='w-10 h-12 sm:w-12 sm:h-14 text-center text-xl sm:text-2xl font-bold bg-white/10 border-2 border-white/20 text-white rounded-lg focus:ring-2 focus:ring-[#FF6F3C] focus:border-[#FF6F3C] outline-none transition'                                            required
                                        />
                                    ))}
                                </div>
                            </div>

                            <button
                                type='submit'
                                disabled={loading || otp.join('').length !== 6}
                                className='w-full bg-[#FF6F3C] hover:bg-[#ff4c0b] text-white font-semibold py-3 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed'
                            >
                                {loading ? 'Completing Setup...' : 'Complete Setup'}
                            </button>

                            <button
                                type='button'
                                onClick={handleBackToForm}
                                className='w-full border-2 border-[#FF6F3C] text-[#FF6F3C] hover:bg-white/10 font-semibold py-3 rounded-lg transition duration-200'
                            >
                                Back to Form
                            </button>

                            <div className='text-center'>
                                <p className='text-sm text-gray-400 mb-2'>Didn't receive the code?</p>
                                <button
                                    type='button'
                                    onClick={handleResendOTP}
                                    disabled={countdown > 0 || resendLoading}
                                    className='text-[#FF6F3C] hover:text-[#ff4c0b] font-semibold text-sm disabled:opacity-50 disabled:cursor-not-allowed'
                                >
                                    {resendLoading ? 'Sending...' : countdown > 0 ? `Resend in ${countdown}s` : 'Resend Code'}
                                </button>
                            </div>
                        </form>

                        <div className='mt-6 flex items-start gap-2 text-xs text-gray-500'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" className="flex-shrink-0 mt-0.5">
                                <path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M11 7h2v2h-2zm0 4h2v6h-2z"/>
                            </svg>
                            <p>
                                {step === 1
                                    ? "After setup, you'll be logged out and must login with your new credentials"
                                    : "This code will expire in 10 minutes. Check your spam folder if you don't see the email."}
                            </p>
                        </div>
                    </div>
                )}
        </div>
    )
}